// extracted by mini-css-extract-plugin
export default {"jobNav":"styles_jobNav__x36QH"};